import { useEffect } from "react";

const useAppMeasurement = () => {
    useEffect(() => {
        if (typeof AppMeasurement !== "undefined") {
            let suite = process.env.REACT_APP_MRMReportSuite || "";
            window.s = new AppMeasurement(suite);
            window.s.account = suite;
            window.s.trackingServer = "generalmotorscorporation.sc.omtrdc.net";
            if (!window.s.apl) {
                window.s.apl = apl; // Use the custom apl implementation
            }
            //console.log("AppMeasurement loaded.");
        } else {
            console.error("AppMeasurement is not defined after loading the script.");
        }
    }, []);


    const apl = (list: string, value: string, delimiter: string, maxLength?: number): string => {
        // Split the list into an array, removing duplicates
        const items = list && list.split(delimiter).filter((item) => item.trim() !== "");
        const values = value && value.split(delimiter);

        if (values && items) {
            // Add new values to the list if not already present
            values.forEach((val) => {
                if (!items.includes(val)) {
                    items.push(val);
                }
            });

            // Join the list back into a delimited string
            let result = items.join(delimiter);

            // Truncate if maxLength is provided
            if (maxLength && result.length > maxLength) {
                result = result.substring(0, maxLength);
            }

            return result;
        }
        return "";

    };
};

export default useAppMeasurement;
